<template>
  <div id="class_inside">
    <div class="con_all">
      <div class="con_box2">
        <div class="psear mb10">
          <div class="ca_l">
            <span class="con_title con_title_line">{{showPage.class_inside}}</span>
          </div>
          <div class="ca_l">
            <div class="ca_r">
              <router-link :to="{ name: 'class_item', params:{classname: className}}">
                <button class="ca_btn">{{showPage.class_item}}</button>
              </router-link>
            </div>
            <div class="ca_r2">
              <router-link :to="{ name: 'coach_info', params:{classname: className}}">
                <button class="ca_btn">{{showPage.coach_info}}</button>
              </router-link>
            </div>
            <div class="ca_r2">
              <router-link :to="{ name: 'facility', params:{classname: className}}">
                <button class="ca_btn">{{showPage.facility}}</button>
              </router-link>
            </div>
          </div>
        </div>
        <div class="fix" style="margin-bottom: 10px;"></div>
        <div class="team_bbox" v-html="showNote()"></div>
        <div class="fix"></div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message, ShowPage } from '@/assets/project_setting/config';
import { GetErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';

export default {
  name: 'class_inside',
  props: ['classitem'],
  data() {
    return {
      className: this.$route.params.classname,  
      locale: sessionStorage.getItem('locale'),
      showPage: ShowPage(sessionStorage.getItem('locale')),
    };
  },
  created() {
  },
  methods: {
    
    
    
    showNote() {
      return sessionStorage.locale === 'CH' ? (this.classitem.noteCh) : (this.classitem.noteEn);
    }
  },
}

</script>
<style lang="scss">


</style>



// WEBPACK FOOTER //
// ClassInside.vue?53703fb9